<template>
    <div>
        <v-card>
            <v-card-text>
                <h4>
                    You seem to be using an unsupported browser. <br/>
                    Please use any of Chrome, Firefox or Safari browsers for a seamless test answering experience
                </h4>
                <div class="d-flex justify-center">
                    <v-btn
                        @click="onClose({ status: false })"
                        class="mr-3"
                        color="secondary"
                        >Close</v-btn
                    >
                </div>                
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: "BrowserSupport",
    props: ["onClose", "status", "data"],
    computed: {},
};
</script>

